export default {"src":"/_next/static/media/LogisticsIconRed.b1180de0.svg","height":14,"width":19,"blurWidth":0,"blurHeight":0};